import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApmTranslatePipe } from '@mitsubishi/core';

import { FieldType, FieldTypeConfig, FormlyAttributes } from '@ngx-formly/core';

@Component({
  selector: 'apm-table-input-type',
  templateUrl: './table-input-type.component.html',
  styleUrls: ['./table-input-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ReactiveFormsModule, FormlyAttributes, ApmTranslatePipe],
})
export class TableInputTypeComponent extends FieldType<FieldTypeConfig> {
  ignoredKeyCodes = ['KeyE'];

  onKeyDown(e: KeyboardEvent) {
    if (this.ignoredKeyCodes.includes(e.code)) {
      e.preventDefault();
    }
  }
}
